import { render, staticRenderFns } from "./ElementMixin.js.vue?vue&type=template&id=31e8d77a&"
import script from "./ElementMixin.js.vue?vue&type=script&lang=js&"
export * from "./ElementMixin.js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports